import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import s from './OwnedByUser.scss';
const OwnedByUser = ({ owner, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(UserLink, {
        className: classnames(s['root'], className),
        user: owner
    }, t('sidebar.blockTitle.owned_by', {
        postProcess: 'reactPostprocessor',
        owner: /*#__PURE__*/ React.createElement(BasicUserName, {
            user: owner
        })
    }));
};
OwnedByUser.displayName = 'OwnedByUser';
export default OwnedByUser;
